/**
 * Logo Component
 * Application logo for AppBar
 */

import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { PROTECTED_ROUTES } from '@/routes/routes';
import { APP_LOGO_ALT, APP_LOGO_DASHBOARD_LABEL } from '@/constants/brand';

export const Logo: React.FC = () => {
  return (
    <Box
      component={Link}
      to={PROTECTED_ROUTES.DASHBOARD}
      sx={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        '&:focus-visible': {
          outline: '2px solid',
          outlineColor: 'primary.light',
          outlineOffset: 2,
          borderRadius: 1,
        },
      }}
      aria-label={APP_LOGO_DASHBOARD_LABEL}
    >
      <Box
        component="img"
        src="/images/logo.svg"
        alt={APP_LOGO_ALT}
        sx={{
          height: { xs: 28, sm: 32, md: 36 },
          width: 'auto',
          // Logo SVG has its own Mensova brand colours.
        }}
      />
    </Box>
  );
};
